<template>
  <div class="privacy-block">
    <!-- 隐私声明全部内容文本输入框 -->
    <vh-input
      :disabled="false"
      v-model.trim="value.content"
      show-word-limit
      autocomplete="off"
      type="textarea"
      :autosize="{ minRows: 4 }"
      :placeholder="activeConfig.contentPlaceholder"
      :maxlength="1000"
      :key="value.id"
      class="radioInput"
    ></vh-input>

    <div class="privacy-block__option" v-for="(item, index) in optionsList">
      <!-- 待添加连接的文本输入框 -->
      <vh-input
        :disabled="false"
        v-model.trim="item.color_text"
        @input="validateInputForColorText($event, item)"
        show-word-limit
        autocomplete="off"
        type="text"
        :placeholder="activeConfig.colorTextPlaceholder"
        :maxlength="1000"
        class="radioInput privacy-input__colortext"
      >
        <i
          v-if="index === 0 && optionsList.length < 5"
          class="vh-icon-circle-plus-outline opera-icon"
          slot="suffix"
          @click="handleAdd"
        ></i>
        <i
          v-else-if="index > 0"
          class="vh-icon-remove-outline opera-icon"
          slot="suffix"
          @click="handleRemove(index)"
        ></i>
      </vh-input>
      <!-- 链接输入框-->
      <vh-input
        :disabled="false"
        v-model.trim="item.url"
        show-word-limit
        autocomplete="off"
        type="textarea"
        :autosize="{ minRows: 2 }"
        :placeholder="activeConfig.urlPlaceholder"
        :maxlength="200"
        @change="handleChangeUrl(item)"
        class="radioInput privacy-input__url"
      ></vh-input>
    </div>
  </div>
</template>
<script>
  import RelatedConfig from './config';

  export default {
    name: 'PrivacyBlock',
    data() {
      return {};
    },
    props: {
      // 1 中文，2：英文, 默认为 1
      languageType: {
        type: [Number, String],
        default: 1
      },
      // 接收v-model中的数据
      value: {
        type: Object,
        required: true,
        default() {
          return {};
        }
      }
    },
    computed: {
      optionsList() {
        return this.value.options || [];
      },
      activeConfig() {
        return this.languageType == 2 ? RelatedConfig['en'] : RelatedConfig['zh'];
      }
    },
    methods: {
      validateInputForColorText(val, item) {
        // 校验内容是否是第1行中包含的文字
        if (val && (this.value.content || '').indexOf(val) === -1) {
          item.color_text = '';
        }
      },
      // 添加选项
      handleAdd() {
        if (this.optionsList.length == 5) return;
        if (!this.value.options) this.value.options = [];
        this.value.options.push({
          color_text: '',
          url: ''
        });
      },
      // 移除选项
      handleRemove(index) {
        this.value.options.splice(index, 1);
      },
      handleChangeUrl(item) {
        const reg = /http[s]{0,1}:\/\/([\w.]+\/?)\S*/;
        if (!reg.test(item.url)) {
          this.$vhMessage({
            message: this.$t('lang.k_382001'),
            showClose: true,
            // duration: 0,
            type: 'error',
            customClass: 'zdy-info-box'
          });
          item.url = '';
        }
      }
    }
  };
</script>
<style lang="less" scoped>
  .privacy-block {
    &__option {
      margin-top: 10px;

      .opera-icon {
        font-size: 16px;
        color: #666666;
        vertical-align: middle;
        display: none;
        cursor: pointer;
        margin-right: 10px;
      }
    }

    ::v-deep .privacy-input__colortext {
      .vh-input__inner {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }

      &:hover .opera-icon {
        display: inline-block;
      }
    }
    ::v-deep .privacy-input__url {
      top: -1px;
      .vh-textarea__inner {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
      }
    }
  }
</style>
